import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import { AiOutlineTwitter } from 'react-icons/ai';
import {IoLogoWhatsapp} from 'react-icons/io'

export default function HeaderSocials() {
  return (
    <div className='header__socials'>
      <a href='https://al.linkedin.com/in/rigers-allaraj-5bb234160' title='LinkedIn' target='_blank'>
        <BsLinkedin className='btn-animation'/>
      </a>
      <a href='https://github.com/rigers-allaraj' title='Github' target='_blank'>
        <FaGithub className='btn-animation'/>
      </a>
      <a href='https://api.whatsapp.com/send?phone=355684818539' title='Whatsapp' target='_blank'>
        <IoLogoWhatsapp className='btn-animation'/>
      </a>
      🤙 My Social Networks
    </div>
  );
}
